export default __webpack_public_path__ + "static/media/rambouillet26.0e95a0ae.jpg";